"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../../");
var context_1 = require("../../../context");
var SectionHeading_1 = __importDefault(require("../../SectionHeading"));
var EthnicityDetailsProfile = function (_a) {
    var client = _a.client;
    var trans = context_1.useSemantics().trans;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeading_1.default, { className: "pb-8", heading: trans('optiiva::headings.ethnicity'), subHeading: trans('optiiva::headings.personal') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, label: trans('optiiva::labels.ethnicity'), value: client.ethnicity_readable || trans('optiiva::misc.empty-line') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, label: trans('optiiva::labels.sub-ethnicity'), value: client.sub_ethnicity_readable || trans('optiiva::misc.empty-line') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, label: trans('optiiva::labels.religion'), value: client.religion_readable || trans('optiiva::misc.empty-line') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, label: trans('optiiva::labels.language'), value: client.language_readable || trans('optiiva::misc.empty-line') }),
        react_1.default.createElement(__1.DataRow, { horizontal: true, label: trans('optiiva::labels.interpreter'), value: client.interpreter_readable || trans('optiiva::misc.empty-line') })));
};
exports.default = EthnicityDetailsProfile;
//# sourceMappingURL=EthnicityDetailsProfile.js.map